module.exports = __webpack_public_path__ + "img/1.095e7ecf.jpg";